<div class="project-server-content">
  <!-- Server -->
  @if (server) {
    <div class="server">
      <div class="row">
        <input class="input transparent name" [(ngModel)]="server.serverName" (blur)="updateServer()" placeholder="Server name..." autoSizeInput [extraWidth]="20">
        <div class="server-type" [matMenuTriggerFor]="serverTypeMenu">{{ server.type }}</div>
        <mat-menu #serverTypeMenu="matMenu">
          <ng-template matMenuContent>
            <button mat-menu-item (click)="changeServerType('aws')">aws</button>
            <button mat-menu-item (click)="changeServerType('selfHosted')">selfHosted</button>
            <button mat-menu-item (click)="changeServerType('docker')">docker</button>
          </ng-template>
        </mat-menu>
      </div>
      @if (server.type === 'selfHosted') {
        <div class="row">
          <input class="input transparent self-hosted" [(ngModel)]="server.serverKey" (blur)="updateServer()" placeholder="Self-hosted key...">
        </div>
      }
      <div class="version">{{ server.version }}</div>
    </div>
    <div class="horizontal-line"></div>
  }
  <!-- Deliverables -->
  @if (server && server.deliverables) {
    <div class="row">
      <div class="title">
        <div>Deliverables</div>
        <div class="button-create">
          <mat-icon svgIcon="plus" class="icon" (click)="addDeliverableFormat()"></mat-icon>
        </div>
      </div>
      @for (deliverable of server.deliverables; track deliverable.format; let index = $index) {
        <div class="deliverable">
          <app-select class="select" [options]="recordOptions.deliverableFormat" [selected]="deliverable.format" (selectedChange)="updateDeliverableFormat($event, index)"></app-select>
          <app-select class="select" [options]="destinationOptions" [selected]="deliverable.destinations" (selectedChange)="updateDeliverableDestination($event, index)" [multiple]="true"></app-select>
          @if (permissions | includesBy: 'project:update') {
            <div class="button-delete">
              <mat-icon svgIcon="trash" class="icon" (click)="deleteDeliverable(index)"></mat-icon>
            </div>
          }
        </div>
      }
    </div>
  }
  <!-- Settings -->
   <div class="row">
    <div class="title">
      <div>Settings</div>
    </div>
    <!-- Tasks Textarea -->
    <div class="settings-content">
      <textarea class="settings-input" [(ngModel)]="settingsText" (blur)="updateSettings()"></textarea>
    </div>
  </div>
  <!-- AWS Overrides -->
  @if (server && server.type === 'aws') {
    <div class="row">
      <div class="title">
        <div>AWS Overrides</div>
      </div>
      <div class="settings-content">
        <textarea class="settings-input"
                  placeholder='Optional. e.g. { "region": "us-west-2", "instanceType": "g5.8xlarge" }'
                  [(ngModel)]="awsOverridesText"
                  (blur)="updateAwsOverrides()"></textarea>
      </div>
    </div>
  }
  <!-- Tasks -->
  <div class="row">
    <div class="title">
      <div>Tasks</div>
    </div>
    <!-- Tasks Textarea -->
    <div class="tasks-content">
      <textarea class="tasks" [(ngModel)]="tasks"></textarea>
      <div class="tasks-actions">
        <div class="button secondary graph" (click)="showGraph = !showGraph">
          <mat-icon svgIcon="chart-graph" class="icon"></mat-icon>
        </div>
        <div class="button secondary" (click)="setGeneralTemplate()">Bill Maher</div>
        <div class="button secondary" (click)="setTranscodeTemplate()">John Oliver</div>
        <div class="button secondary" (click)="setNflTemplate()">NFL</div>
        <div class="button secondary" (click)="setC3Template()">C3</div>
        <div class="button" (click)="saveTasks()">Save</div>
      </div>
    </div>
    <!-- Actions -->
    <div class="actions">
      <div class="button-delete">
        <mat-icon svgIcon="trash" class="icon" (click)="deleteServer()"></mat-icon>
      </div>
    </div>
    <!-- Diagram -->
    @if (server && showGraph) {
      <app-tasks-mermaid class="tasks-diagram" [tasks]="server.taskTemplates"></app-tasks-mermaid>
    }
  </div>
</div>